import script from "./MainScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./MainScreen.vue?vue&type=script&setup=true&lang=js"

import "./MainScreen.vue?vue&type=style&index=0&id=66498813&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66498813"]])

export default __exports__